export default "data:application/octet-stream;base64,"